export default __webpack_public_path__ + "static/media/big-rombus.4473d513.svg";